import { Tooltip, Svg } from "@impero-com/ui";
import { cx } from "class-variance-authority";

import InformationCircle from "../../img/information-circle.svg";

import * as theme from "./theme.css";

interface InfoTooltipProps {
    text?: string;

    /**
     * Specifies the class to be applied to the icon.
     * When not specified a default class is applied.
     * `null` means no class should be applied at all.
     */
    iconClassName?: string | null;
}
export const InfoTooltip = ({
    text,
    iconClassName = theme.infoIcon,
}: InfoTooltipProps) => {
    return text ? (
        <Tooltip title={text}>
            <span>
                <Svg src={InformationCircle} className={cx(iconClassName)} />
            </span>
        </Tooltip>
    ) : null;
};
